







import Vue from 'vue'
import router from '@/router';
import { store } from '@/store';

export default Vue.extend({
    name: 'motifs',
    data() {
        return {
            columns: [{
                name: 'name',
                label: 'Name',
                sortable: true,
                field: 'name'
            }, {
                name: 'type',
                label: 'Type',
                field: 'type'
            }],
            pagination: {
                sortBy: 'name',
                rowsPerPage: 25
            }
        }
    },
    computed: {
        data() {
            return Object.values(store.state.dataset.topic_metadata);
        }
    },
    methods: {
        gotoMotif: function(_event: any, {name}: any) {
            router.push({name:'motif', params: {name}})
        }
    }
})
